export default {
  seekBtn(type) {
    // type 1 救助服务 2 健康体检 3 认知筛选 4 法律咨询
    const pages = {
      31: "/healthManager/list?aType=31&aTitle=非医疗紧急转运救援",
      13: "/healthManager/list?aType=13&aTitle=健康体检",
      3: "/healthManager/list?aType=5&aTitle=认知症早筛",
      34: "/healthManager/list?aType=34&aTitle=法律咨询",
    };
    return pages[type] ?? "";
  },
};